import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { modalStyle } from '.';
import Typography from '@mui/material/Typography';

const UNCLAIM_REASONS = [
  '',
  'Claimed in Error',
  'Non-participating Provider',
  'Sex Offender Status',
  'Agency Exclusion',
  'Different Level of Care Needed',
  'Hospital Not Answering',
  'Misrouted',
];

const UnclaimModal = ({
  handleUnclaimClick,
  isUnclaimModalOpen,
  setIsUnclaimModalOpen,
}) => {
  const [unclaimReason, setUnclaimReason] = useState(UNCLAIM_REASONS[0]);
  return (
    <Modal
      open={isUnclaimModalOpen}
      onClose={() => {
        setIsUnclaimModalOpen(false);
      }}
      aria-labelledby='unclaim-alert-modal'
      aria-describedby='modal-to-unclaim-alerts'
    >
      <Box sx={{ ...modalStyle, width: 400 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <FormControl>
            <InputLabel id='unclaim-label'>Select a Reason</InputLabel>
            <Select
              labelId='unclaim-label'
              id='unclaim'
              value={unclaimReason}
              label='unclaim'
              onChange={(e) => setUnclaimReason(e.target.value)}
            >
              {UNCLAIM_REASONS.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                >
                  {!option ? <em>None</em> : option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            onClick={() => {
              handleUnclaimClick(unclaimReason || null);
            }}
          >
            Done
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UnclaimModal;
